export interface ProcessBarcodeRequest {
  barcode: String;
  parcelCenterId: string;
}

export function BarcodeReceivingModel(
  barcode: String,
  parcelCenterId: string
): ProcessBarcodeRequest {
  return {
    barcode: barcode,
    parcelCenterId: parcelCenterId,
  };
}
